import { render, staticRenderFns } from "./KnowLedgeGraph.vue?vue&type=template&id=4ce199d3&scoped=true&"
import script from "./KnowLedgeGraph.vue?vue&type=script&lang=js&"
export * from "./KnowLedgeGraph.vue?vue&type=script&lang=js&"
import style0 from "./KnowLedgeGraph.vue?vue&type=style&index=0&id=4ce199d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce199d3",
  null
  
)

export default component.exports